import React from 'react'
import Testimonial from './../components/home/Testimonial.jsx';
import Connect from '../components/Connect.jsx';
import Introbanner from './../components/about/Introbanner.jsx';
import Introtoggle from './../components/about/Introtoggle.jsx';

const About = () => {
  return (
    <>
      <div className="">
      <Introbanner />
      <Introtoggle />
      <Testimonial />
      <Connect />
      </div>
    </>
  )
}

export default About
